import endpoints from '@/utils/constants';
import {apiHelper} from '@/utils/helpers';

const actions = {

     getCreditNotes(context){
         return new Promise((resolve,reject)=>{
            apiHelper.call('get',`${endpoints.BASE_URL}${endpoints.API.creditNotes}`)
            .then((res) => {
                if(res.status === 200){
                    context.commit('setCreditNoteList',res.data);
                }
            }).catch(err => {
                reject(err)
            })
         })

    },

    
}
export default actions;